import { api } from '../core';

export interface MarkNotBlankRequest {
  pageIds: string[];
}

export interface MarkNotBlankProps {
  abortController?: AbortController;
  pageIds: string[];
}

const markNotBlankApi = api.injectEndpoints({
  endpoints: (builder) => ({
    markNotBlank: builder.mutation<null, MarkNotBlankProps>({
      query: ({ abortController = new AbortController(), pageIds }: MarkNotBlankProps) => ({
        url: 'gdpr/mark/not-blank',
        method: 'POST',
        signal: abortController.signal,
        body: {
          pageIds
        }
      }),
      extraOptions: { maxRetries: 3 }
    })
  })
});

export const { useMarkNotBlankMutation } = markNotBlankApi;
